import { MEDIA_SERVER_BASE_URL } from "api/constants";

export const createMediaUrl = (file: {
  id?: string | null;
  hash?: string | null;
}) => {
  if (!file.id || !file.hash) {
    return null;
  }

  return MEDIA_SERVER_BASE_URL + `${file.id}?hash=${file.hash}`;
};
